import { computed, useContext, wrapProperty } from "@nuxtjs/composition-api";

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useTranslate
 * @desc     A simple composable that merely wraps the $gettext plugin into a
 *           simple composable accessor. Will need to be removed when we move
 *           to a CMS.
 *
 * @summary  Returns a string of the translation of the message. Also makes the
 *           string discoverable by gettext-extract.
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @param msgid — The translation key
 *
 * @return — The translated string
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useTranslate = () => {
  const ctx = useContext().i18n;
  return {
    t: (msgid: string, values?: { [key: string]: string }) => computed(() => ctx?.t(msgid, values) as string),
    tc: (msgid: string, choice?: number, values?: { [key: string]: string }) =>
      computed(() => ctx?.tc(msgid, choice, values) as string),
  };
};

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useI18n
 * @desc     A simple composable that merely wraps the $i18n plugin into a
 *           composable accessor. Might remove for better config approach
 *           with the composables API.
 *
 * @summary  Composable used to access the $i81n plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useI18n = wrapProperty("$i18n", false);
